import { readonly, ref } from 'vue'
import { isNavigationFailure, NavigationFailureType, type Router } from 'vue-router'

const navigating = ref(false)
export const isNavigating = readonly(navigating)

export function registerNavigationLoading(router: Router) {
  router.beforeEach(() => {
    navigating.value = true
  })
  router.afterEach((_to, _from, failure) => {
    if (!isNavigationFailure(failure, NavigationFailureType.cancelled)) {
      navigating.value = false
    }
  })
  router.onError(() => {
    navigating.value = false
  })
}

export async function trackNavigation(navigation: () => Promise<unknown>) {
  navigating.value = true
  try {
    await navigation()
  } catch (error) {
    navigating.value = false
    throw error
  }
}
